module.exports = __webpack_public_path__ + "img/jed-pro.da544a08.jpg";